module.exports = __webpack_public_path__ + "static/media/ashutosh_pardeshi.e4daec46.png";